import { render, staticRenderFns } from "./TestCross.vue?vue&type=template&id=3919a401&"
import script from "./TestCross.vue?vue&type=script&lang=ts&"
export * from "./TestCross.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports